import { useEffect } from 'react'
import { trackEvent } from '../../../../utils/appBridge'
import BottomSheetContent from '../../BottomSheetContent'
import { EventNames } from '../../../../types/misc.types'
import RenderHTML from '../../../ui-components/RenderHTML'
import { oneTimeInvestIcon } from '../../../../utils/mf-execution/buttonsConfig'
import { autoPayIcon } from '../../../../utils/mf-execution/paymentPageConfig'
import { PrimaryButton } from '../../../execution/PrimaryButton'
import { formatIndianNumber } from '../../../../utils/FD/fd'

export const BuyAutoPayConfirmationBottomSheet = ({
  onDismiss,
  ScreenName,
  amount,
  displayAccNumber,
  onPlaceOrder,
  trackingFund
}: {
  onDismiss: () => void
  ScreenName: string
  amount: number
  displayAccNumber: string
  onPlaceOrder: () => void
  trackingFund?: { fundIsin: string; fundName: string }
}) => {
  const heading = 'Review details'

  useEffect(() => {
    trackEvent({
      eventName: EventNames.BottomSheetLoad,
      payload: {
        bottomSheetName: 'Buy review details',
        ...(trackingFund ?? {})
      }
    })
  }, [])

  return (
    <BottomSheetContent
      heading={heading}
      onDismiss={onDismiss}
      bottomSheetHeadingClassName='!font-[500]'
      bottomSheetBodyClassName='!px-0 !pb-4'
      bottomSheetCtas={
        <PrimaryButton
          onClick={onPlaceOrder}
          label='Place Order'
          primaryButtonClassName='!h-[56px] !text-[16px] !font-[500]'
        />
      }
    >
      <div className='flex flex-col pt-6 border-t border-[#F0F4F7]'>
        {/* One-time investment */}
        <div className='flex items-center gap-5 w-full pl-5'>
          <div>
            <RenderHTML innerHTMLText={oneTimeInvestIcon} />
          </div>
          <div className='flex w-1 flex-1'>
            <div className='flex flex-col'>
              <div className='text-[#8E9393] font-[400] text-[13px]'>One-time investment</div>
              <div className='text-[#232323] text-[22px] font-[500]'>{formatIndianNumber(amount, true)}</div>
            </div>
          </div>
        </div>
        <div className='pl-16 py-4'>
          <div className='bg-[#F0F4F7] h-[1px] w-full'></div>
        </div>
        {/* Auto Pay */}
        <div className='flex items-center gap-[14px] w-full pl-[14px]'>
          <div>
            <RenderHTML innerHTMLText={autoPayIcon} />
          </div>
          <div className='flex w-1 flex-1'>
            <div className='flex flex-col'>
              <div className='text-[#232323] text-[14px] font-[500]'>Pay via Autopay</div>
              <div className='text-[#6A6E6E] text-[13px] font-[400] pt-[2px]'>{displayAccNumber}</div>
            </div>
          </div>
        </div>
        {/* Auto Pay Note */}

        <div
          style={{ background: 'linear-gradient(90deg, #F0F4F7 0%, rgba(240, 244, 247, 0.00) 100%)' }}
          className='text-[#6A6E6E] font-[400] text-[13px] rounded-[8px] px-[8px] py-[4px] pr-10 ml-[68px] mt-3 w-max'
        >
          Auto debited in 1–2 working days
        </div>
      </div>
    </BottomSheetContent>
  )
}
